import { useAsyncAnalysisLoader } from '@/components/group-tables/use-async-analysis-loader';

type UseSingleGroupTableAnalysisArgs<TTarget, TData> = {
    load: (target: TTarget, args: { signal: AbortSignal }) => Promise<TData>;
    errorMessage: string;
};

export const useSingleGroupTableAnalysis = <TTarget, TData>({
    load,
    errorMessage,
}: UseSingleGroupTableAnalysisArgs<TTarget, TData>) =>
    useAsyncAnalysisLoader<TTarget, TData>({
        load,
        errorMessage,
    });

type UseDualGroupTableAnalysisArgs<TTarget, TPrimaryData, TSecondaryData> = {
    primary: {
        load: (target: TTarget, args: { signal: AbortSignal }) => Promise<TPrimaryData>;
        errorMessage: string;
    };
    secondary: {
        load: (target: TTarget, args: { signal: AbortSignal }) => Promise<TSecondaryData>;
        errorMessage: string;
    };
};

export const useDualGroupTableAnalysis = <TTarget, TPrimaryData, TSecondaryData>({
    primary,
    secondary,
}: UseDualGroupTableAnalysisArgs<TTarget, TPrimaryData, TSecondaryData>) => {
    const primaryAnalysis = useAsyncAnalysisLoader<TTarget, TPrimaryData>({
        load: primary.load,
        errorMessage: primary.errorMessage,
    });
    const secondaryAnalysis = useAsyncAnalysisLoader<TTarget, TSecondaryData>({
        load: secondary.load,
        errorMessage: secondary.errorMessage,
    });

    return {
        primaryAnalysis,
        secondaryAnalysis,
    };
};
